import { cn } from '@/lib/utils';
import React from 'react';

const HeaderWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return (
    <header
      className={cn(
        'flex items-center justify-between p-4 border-b bg-[#181A32] border-gray-800',
        className,
      )}
    >
      {children}
    </header>
  );
};

export default HeaderWrapper;
